import React from 'react';
import AccountSettingsView from './AccountSettingsView';
import ProfileEdit from './ProfileEdit';
import useAccountSettings from './AccountSettingsLogic';

const AccountSettings = () => {
  const {
    userData,
    loading,
    error,
    isAdvancedOpen,
    subscription,
    planDetails,
    systemVersion,
    isPortalLoading,
    portalError,
    showProfileEdit,
    handleSubscriptionManage,
    handleUpgradeToBusiness,
    toggleAdvanced,
    handleOpenProfileEdit,
    handleCloseProfileEdit,
    handleProfileSuccess
  } = useAccountSettings();

  return (
    <>
    <AccountSettingsView
      userData={userData}
      loading={loading}
      error={error}
      isAdvancedOpen={isAdvancedOpen}
      subscription={subscription}
      planDetails={planDetails}
      systemVersion={systemVersion}
        isPortalLoading={isPortalLoading}
        portalError={portalError}
      handleSubscriptionManage={handleSubscriptionManage}
      handleUpgradeToBusiness={handleUpgradeToBusiness}
      toggleAdvanced={toggleAdvanced}
        handleOpenProfileEdit={handleOpenProfileEdit}
      />
      
      {showProfileEdit && userData && (
        <ProfileEdit 
          userData={userData}
          onClose={handleCloseProfileEdit}
          onSuccess={handleProfileSuccess}
        />
      )}
    </>
  );
};

export default AccountSettings; 